<div class="alert" [ngClass]="{'active':showAlert}">
    <ng-content select="fui-panels-alert"></ng-content>
</div>
<div class="panels" [ngClass]="{'inactive':showAlert}">
    <ng-content select="fui-panel"></ng-content>
</div>
